<template>

  <footer>
    <div class="container">  
                <div class="row">
                    <div class="col-md-3 mb-3">
                        <img class="logo" src="../assets/img/logo_white_skanticket.png" alt="" srcset="">
    
                        <p></p>
                        <hr class="divider left" style="width: 4em;"/>
                        <span>Moyens de paiement</span>
                        <p></p>
                        <ul class="list-inline payment-logo">
                                <li class="list-inline-item">
                                    <img src="../assets/img/momo.png" alt="" srcset="">
                                </li>
                                <li class="list-inline-item">
                                    <img src="../assets/img/om.png" alt="" srcset="">
                                </li>
                                <li class="list-inline-item">
                                    <img src="../assets/img/moovmoney.png" alt="" srcset="">
                                </li>
                                <li class="list-inline-item">
                                        <img src="../assets/img/visa.png" alt="" srcset="">
                                </li>
                        </ul>
                    </div>
                    <div class="col-md-3">
                        <h2 class="title">Utiliser SkanTicket</h2>
                        <ul class="list-unstyled">
                                <li>
                                    <a href="https://billeterie.skanticket.com/inscription">Creer une billeterie</a>
                                </li>
                                <li>
                                    <a href="https://play.google.com/store/apps/details?id=ci.innovlabs.skanevent&hl=fr">Application Android</a>
                                </li>
                                <li>
                                    <a href="https://itunes.apple.com/us/app/skanticket/id1169570285?mt=8">Application iOS</a>
                                </li>
                                <li>
                                    <router-link to="/ussd">Application USSD</router-link>
                                </li>
                        </ul>
                    </div>
                    <div class="col-md-3">
                            <h2 class="title">Catégories</h2>
                            <ul class="list-unstyled">
                                    <li>
                                        <router-link to="/evenement/CINEMA">Cinema</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/evenement/EVENEMENTS">Evenements</router-link>
                                    </li>
                            </ul>
                    </div>
                    <div class="col-md-3">
                            <h2 class="title">Rester connectés</h2>
                            <ul class="list-unstyled">
                                    <li>
                                        <a href="https://facebook.com/skanticket/">Facebook</a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/skanticket">Twitter</a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UCmsVKF5Qv7HFIM26uTZXqUw/videos">Youtube </a>
                                    </li>
                                    <li>
                                        <router-link to="/apropos">Nous contacter</router-link>
                                    </li>
                            </ul>
                    </div>
                </div>
                <hr class="divider-full">
                <div class="text-center pb-3">
                    <router-link to="/apropos">A propos de SkanTicket</router-link>
                    - 
                    <a href="">Conditions d’utilisation</a>
                    - 
                    <a href="">Confidentialité</a>
                </div>
            </div>
            <div class="copyright p-3">
                <div class="container">
                    <div class="row">
                        <div class="col text-left">
                            <small>copyright Ⓒ 2019 -  <a href="">SKAN TECHNOLOGIES</a> </small>
                        </div>
                        <!--<div class="col text-right">
                            <small>Design by 
                               <a href=""><b>GLADUX Group</b></a> 
                            </small>
                        </div>-->
    
                    </div>
    
                </div>
            </div>          
  </footer>

</template>

<script lang="js">
  export default  {
    name: 'pied-de-page',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

